import { Injectable } from '@angular/core';
import '@rschedule/moment-date-adapter/setup';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from 'src/app/shared/models/api-response.model';
// import moment = require('moment-recur');
@Injectable({
  providedIn: 'root'
})
export class ExperienceScheduleService {
  constructor(
    private http: HttpClient
  ) {}

  /** API CALLS */
  getAllExperiences() {
    return this.http.get<ApiResponseModel>('/api/experience').toPromise();
  }

  getExperienceById(experienceId) {
    return this.http.get<ApiResponseModel>('/api/experience/' + experienceId).toPromise();
  }

  getExperienceAvailability(experienceId) {
    return this.http.get<ApiResponseModel>('/api/availability/experience/' + experienceId).toPromise();
  }

  addAvailabilityInstance(id, active, date, extras?: any) {
    return this.http.post<ApiResponseModel>('/api/availability/experience/' + id, {active, date, ...extras}).toPromise();
  }

  updateAvailabilityInstance(availabilityId, active) {
    return this.http.patch<ApiResponseModel>('/api/availability/' + availabilityId, { active }).toPromise();
  }

  deleteAvailabilityInstance(availabilityId) {
    return this.http.delete<ApiResponseModel>('/api/availability/' + availabilityId).toPromise();
  }

}
